import { render, staticRenderFns } from "./ProductCardRelationShip.vue?vue&type=template&id=42fb790e&"
import script from "./ProductCardRelationShip.vue?vue&type=script&lang=js&"
export * from "./ProductCardRelationShip.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardRelationShip.vue?vue&type=style&index=0&id=42fb790e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports